var _defs, _image, _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScviLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28.84 27.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbb516;stroke:#c3832b;stroke-width:0.5px;opacity:0.77;}.cls-1,.cls-2{stroke-miterlimit:10;}.cls-2{fill:#c3832b;stroke:#a6572a;stroke-width:0.75px;opacity:0.75;}"))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 120,
    height: 122,
    transform: "translate(-71.72 -51.57) scale(0.8)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB6CAYAAAB0rJfZAAAACXBIWXMAAA3XAAAN1wFCKJt4AAACbklEQVR4Xu3cPU4jQRBA4WLZO1jyARw5IUOCAzjyhYi5EBEHAImMZCIOgDSHsLwBamlYe9xt9rdevy+zmexR5Zm24GK/34e4vtUuUG4GhjMwnIHhDAxnYDgDwxkYzsBwBoYzMJyB4QwMZ2A4A8MZGM7AcAaGMzCcgeEMDGdgOAPDGRjOwHAGhjMwnIHhDAxnYDgDwxkYzsBwBoYzMJyB4QwMZ2A4A8MZGM7AcAaGMzCcgeG+1y7oxfP9+unn927uhttj12Zy0ft/my1hr6/Gg5+9vC7SR+468PP9+ulY2KnskXGBj63aObW4RebIqMAtE/lVWSN7Fw2HCfwnpzczTGAdZ2C4rg46Hh8W6+nrzXYc5q6lQNxF1z5/S9jlavfp/fe3y4ioh856Bx3RwYp+fFisl6vdQdyIj+DL1e5gsknSB65Nb4tTkTNPbwQg8CllenuWOvDvmF66tIGN2yZtYLVJGdjpbZcycKvNdhzKs+4p72+Xs8/C11fjWV9B/m/QgSPqkVt+ATLr4qhysx2Huefc2ilWdimPKv/FZ3DWA4+UK/rmbrh9eV3ULlMkDax2KVd08TdWddkUGddzRCc3WS3mVn7WsEXqCY74tSmeRs0eck76wBHnR86+ds/R3YrO+rjzVYgJjqhPcU9TO4UJHPH5z1ZK7F7DFqjAUyV2r2ELbGB98CQLzsBwBoYzMJyB4QwMZ2A4A8MZGM7AcAaGMzCcgeEMDGdgOAPDGRjOwHAGhjMwnIHhDAxnYDgDwxkYzsBwBoYzMJyB4QwMZ2A4A8MZGM7AcAaGMzCcgeEMDGdgOAPDGRjOwHAGhjMw3A8cQ9BZ8LWwBgAAAABJRU5ErkJggg=="
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.85,8.18c.12,1.81-1.17,2.05-1.68,4.39-.81,3.75,2,5.6.91,7.56s-3.55.44-8.21,2.57c-3.38,1.54-3.93,3.13-5.88,2.84s-3.36-2.29-4.53-4c-.85-1.27-1.92-2.87-1.73-4.82.13-1.27.72-1.82,1.64-3.33C8.23,8.69,7,6.71,9,5.57s3.6.95,7-.26c2.25-.8,2.41-2,4-2C22.23,3.3,24.69,5.78,24.85,8.18Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 15,
    cy: 14.06,
    rx: 3.97,
    ry: 4.01,
    transform: "translate(-5.4 11.5) rotate(-35.99)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScviLogo);
export default __webpack_public_path__ + "static/media/scvi-logo.8588e44bd3473540785681a61f76ec81.svg";
export { ForwardRef as ReactComponent };